export default __webpack_public_path__ + "static/media/affiliationsLogos.dc85b98c.png";